import { defineStore } from "pinia";
import { ref } from "vue";

export const useDimensionValuesStore = defineStore(
	"dimensionValuesStore",
	() => {
		const valueType = ref<"nominal" | "bucketed">("nominal");

		return {
			valueType,
		};
	}
);
